import React, { FC } from 'react';
import Navigation from 'evcharging/containers/layout/Navigation';
import Page from 'evcharging/components/Page';
import { createGetServerSideProps, StaticPageProps } from 'evcharging/app';
import Footer from 'evcharging/containers/layout/Footer';
import RequestConsultation from 'evcharging/containers/layout/RequestConsultation';
import { EV_OPEN_ADR_LINK } from 'evcharging/app/seo/pages';
import FaqSection from 'evcharging/containers/layout/FaqSection';
import StayUpdated from 'evcharging/containers/layout/StayUpdated';
import EndToEnd from 'evcharging/containers/layout/EndToEnd';
import WhatIsOpenADR from 'evcharging/containers/open-adr/WhatIsOpenADR';
import YourCar from 'evcharging/containers/open-adr/YourCar';
import SmartEnergy from 'evcharging/containers/open-adr/SmartEnergy';
import Benefits from 'evcharging/containers/open-adr/Benefits';
import WhyOpenAdr from 'evcharging/containers/open-adr/WhyOpenADR';
import { I18nPage } from 'i18n/types/pages.enum';

const OpenAdrPage: FC<StaticPageProps> = ({ page }) => (
  <Page
    locales={page.locales}
    title={page.meta_title}
    description={page.meta_description}
  >
    <Navigation />
    <WhatIsOpenADR />
    <YourCar />
    <WhyOpenAdr />
    <Benefits />
    <SmartEnergy />
    <EndToEnd />
    <RequestConsultation />
    <FaqSection faqs={page.faqs} />
    <StayUpdated />
    <Footer />
  </Page>
);

export const getServerSideProps = createGetServerSideProps(
  EV_OPEN_ADR_LINK,
  undefined,
  [I18nPage.EvChargingOpen, I18nPage.EvChargingCharger, I18nPage.EvChargingOcpp, I18nPage.EnergyRates]
);

export default OpenAdrPage;
